export var DeviationTypes;
(function (DeviationTypes) {
    DeviationTypes["UNKNOWN"] = "unknown";
    DeviationTypes["IMAGE"] = "image";
    DeviationTypes["JOURNAL"] = "journal";
    DeviationTypes["LITERATURE"] = "literature";
    DeviationTypes["FILM"] = "film";
    DeviationTypes["PDF"] = "pdf";
    DeviationTypes["POLL"] = "poll";
    DeviationTypes["COMMISSION"] = "commission";
    DeviationTypes["STATUS"] = "status";
    DeviationTypes["TIER"] = "tier";
})(DeviationTypes || (DeviationTypes = {}));
export var DeviationResourceType;
(function (DeviationResourceType) {
    DeviationResourceType[DeviationResourceType["UNKNOWN"] = 0] = "UNKNOWN";
    DeviationResourceType[DeviationResourceType["ART"] = 1] = "ART";
    DeviationResourceType[DeviationResourceType["JOURNAL"] = 5] = "JOURNAL";
    DeviationResourceType[DeviationResourceType["SITE_POLL"] = 6] = "SITE_POLL";
    DeviationResourceType[DeviationResourceType["POLL"] = 14] = "POLL";
    DeviationResourceType[DeviationResourceType["COMMISSION"] = 66] = "COMMISSION";
    DeviationResourceType[DeviationResourceType["STATUS"] = 69] = "STATUS";
    DeviationResourceType[DeviationResourceType["STATUS_DEVIATION"] = 81] = "STATUS_DEVIATION";
    DeviationResourceType[DeviationResourceType["TIER"] = 82] = "TIER";
})(DeviationResourceType || (DeviationResourceType = {}));
export var DeviationSuggestionReasons;
(function (DeviationSuggestionReasons) {
    DeviationSuggestionReasons[DeviationSuggestionReasons["WatchingUser"] = 1] = "WatchingUser";
    DeviationSuggestionReasons[DeviationSuggestionReasons["WatchingGroup"] = 2] = "WatchingGroup";
    DeviationSuggestionReasons[DeviationSuggestionReasons["WatchingTopic"] = 3] = "WatchingTopic";
    DeviationSuggestionReasons[DeviationSuggestionReasons["Recommended"] = 4] = "Recommended";
    DeviationSuggestionReasons[DeviationSuggestionReasons["DailyDeviation"] = 5] = "DailyDeviation";
    DeviationSuggestionReasons[DeviationSuggestionReasons["NewDeviant"] = 6] = "NewDeviant";
    DeviationSuggestionReasons[DeviationSuggestionReasons["Popular"] = 7] = "Popular";
    DeviationSuggestionReasons[DeviationSuggestionReasons["Boosted"] = 8] = "Boosted";
})(DeviationSuggestionReasons || (DeviationSuggestionReasons = {}));
export var DeviationMatureContentType;
(function (DeviationMatureContentType) {
    DeviationMatureContentType["SAFE"] = "safe";
    DeviationMatureContentType["MODERATE"] = "moderate";
    DeviationMatureContentType["STRICT"] = "strict";
})(DeviationMatureContentType || (DeviationMatureContentType = {}));
export var DeviationAccessSettingsType;
(function (DeviationAccessSettingsType) {
    DeviationAccessSettingsType["ALL"] = "all";
    DeviationAccessSettingsType["FUTURE_ONLY"] = "future_only";
    DeviationAccessSettingsType["LIMITED_PAST_AND_FUTURE"] = "limited_past_and_future";
})(DeviationAccessSettingsType || (DeviationAccessSettingsType = {}));
//# sourceMappingURL=deviation.js.map